/**
 * Mirrors backend/utils/expandLegacyOperatorPermissions.js for client-side checks.
 */
const MANAGE_BILLS_LEGACY_EXPANSION = Object.freeze([
  "bills_view",
  "old_site_bills",
  "enquiries",
  "customer_search",
  "customer_dashboard",
]);

function normalizePermissionArray(permissions) {
  return (permissions || []).map((p) => String(p).trim().toLowerCase());
}

export function expandLegacyOperatorPermissions(permissions) {
  const set = new Set(normalizePermissionArray(permissions));
  if (set.has("manage_bills")) {
    MANAGE_BILLS_LEGACY_EXPANSION.forEach((p) => set.add(p));
  }
  return Array.from(set);
}
